import React from 'react';
import { Link } from '@mui/material';
import styles from './SideNavLinkItem.module.scss';
import { SideNavButtonItem } from '../SideNavButtonItem/SideNavButtonItem';
import { CustomListItemType } from '../../CustomListItem/CustomListItemComponent';
import { useNewLeadsSubscription } from '../../../../hooks/useNewLeadsSubscription';
import { MenuItemsIds } from '../../../../config/useGetNavigationItems';

export default function SideNavLinkItem( {
	listItem,
}: {
	listItem: CustomListItemType;
} ) {
	const { badgeContent } = useNewLeadsSubscription(
		listItem.id !== MenuItemsIds.Leads
	);

	if ( 'href' in listItem ) {
		return (
			<Link href={ listItem.href } className={ styles.linkWrap }>
				<SideNavButtonItem listItem={ listItem } badgeContent={ badgeContent } />
			</Link>
		);
	} else if ( 'onClick' in listItem ) {
		return (
			<SideNavButtonItem listItem={ listItem } badgeContent={ badgeContent } />
		);
	} else {
		return null;
	}
}
